import { render, staticRenderFns } from "./VBroker.vue?vue&type=template&id=19ee8ab7"
import script from "./VBroker.vue?vue&type=script&lang=js"
export * from "./VBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports